{
  "statusOptions": {
    "all": "全部",
    "unpaired": "挂单中",
    "paired": "付款中",
    "paymentMade": "待放币",
    "completed": "交易完成",
    "canceling": "取消中",
    "canceled": "交易取消",
    "forceCanceled": "交易取消",
    "complainted": "修改中",
    "appealing": "申诉中"
  },
  "tags": {
    "buy": {
      "all": "全部",
      "unpaired": "挂单中",
      "paired": "付款中",
      "paymentMade": "待卖家放币",
      "completed": "交易完成",
      "canceling": "卖家取消中",
      "canceled": "交易取消",
      "forceCanceled": "交易取消",
      "complainted": "修改中",
      "appealing": "申诉中"
    },
    "sell": {
      "all": "全部",
      "unpaired": "挂单中",
      "paired": "买家付款中",
      "paymentMade": "待放币",
      "completed": "交易完成",
      "canceling": "取消中",
      "requestCancel": "取消中",
      "canceled": "交易取消",
      "forceCanceled": "交易取消",
      "complainted": "修改中",
      "appealing": "申诉中"
    }
  },
  "fastTrack": {
    "all": "全部",
    "creating": "创建中",
    "awaitSettlement": "等待付款完成",
    "adminResolving": "处理中",
    "completed": "交易完成",
    "failed": "交易失败",
    "timedOut": "已超时"
  }
}
